// extracted by mini-css-extract-plugin
export var form = "_cr-0";